import { useEffect, useState } from "react";
import { CurrentType } from "../../../enum/CurrentType";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppState } from "../../../redux/features/appStateSlice";
import { TenTabLayout } from "./TenTabLayout2";


export const EditReservation = () => {
  const [currentType, setCurrentType] = useState<CurrentType>(CurrentType.EDIT)
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search)
  const primaryKey = queryParams?.get('id') ?? 0;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAppState("carrental.reservations"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TenTabLayout
      currentType={currentType}
      setCurrentType={(value) => setCurrentType(value)}
      _primaryKey={Number(primaryKey)}
      data={{}}
    />
  )
}